import React from 'react';
import { Row, Col } from 'antd';

import image from 'assets/img/fast-forward.svg';

import styles from './HistoryLog.module.less';
import cx from 'classnames';

type Props = {
  oldData: React.ReactNode;
  newData?: React.ReactNode;
  historyId?: string;
};

export default function HistoryLog(props: Props) {
  const { oldData, newData, historyId = '' } = props;
  const hasNewData = newData;

  return (
    <div className={styles.cardContent}>
      <Row gutter={[0, 20]} className="titled-sheet">
        <Col
          xs={24}
          md={12}
          className={cx(hasNewData ? styles.borderBox : undefined)}
        >
          {hasNewData && (
            <img className={styles.image} src={image} alt="arrow" />
          )}

          <div className={styles.wrap} data-id={`wrap-old-data-${historyId}`}>
            {oldData}
          </div>
        </Col>

        {newData && (
          <Col xs={24} md={12}>
            <div
              className={styles.wrapRight}
              data-id={`wrap-new-data-${historyId}`}
            >
              {newData}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}
